<template>
	<div v-if="lodging.userNotifications.length || lodging.histories.length">
		<template v-if="toggleIconsAssistance">
			<span v-for="(history, index) in lodging.histories" :key="`asiin${index}`">
				<v-icon
					dark
					v-if="
						filterPerDay({
							dayTable,
							history: history.in,
							type: 'asi',
						})
					"
					small
					class="ifTodayQuestion"
					:style="{
						'background-color': 'orange',
					}"
				>
					mdi-arrow-up
				</v-icon>
			</span>
			<span v-for="(history, index) in lodging.histories" :key="`asiout${index}`">
				<v-icon
					dark
					v-if="
						filterPerDay({
							dayTable,
							history: history.out,
							type: 'asi',
						})
					"
					small
					class="ifTodayQuestion"
					:style="{
						'background-color': '#03d02f',
					}"
				>
					mdi-arrow-down
				</v-icon>
			</span>
		</template>
		<template v-else>
			<span
				v-for="(notification, index) in getNotifications(lodging.userNotifications, 'sms')"
				:key="`sms${index}`"
			>
				<v-icon
					dark
					v-if="
						filterPerDay({
							type: 'noti',
							dayTable,
							notification,
						})
					"
					dense
					small
					class="ifTodayQuestion"
					:style="{
						'background-color': getStatusColor(notification),
					}"
				>
					mdi-account-question
				</v-icon>
			</span>
			<span
				v-for="(notification, key) in getNotifications(lodging.userNotifications, 'gps')"
				:key="`gps${key}`"
			>
				<v-icon
					dark
					v-if="
						filterPerDay({
							type: 'noti',
							dayTable,
							notification,
						})
					"
					dense
					small
					class="ifTodayQuestion"
					:style="{
						'background-color': getStatusColor(notification),
					}"
				>
					mdi-crosshairs-gps
				</v-icon> </span
			><span
				v-for="(notification, index) in getNotifications(
					lodging.userNotifications,
					'client'
				)"
				:key="`client${index}`"
			>
				<v-icon
					dark
					v-if="
						filterPerDay({
							type: 'noti',
							dayTable,
							notification,
						})
					"
					dense
					small
					class="ifTodayQuestion"
					:style="{
						'background-color': getStatusColor(notification),
					}"
				>
					mdi-gmail
				</v-icon>
			</span>
		</template>
	</div>
</template>

<script>
import moment from 'moment';
import { uniqBy } from 'lodash';

export default {
	props: {
		toggleIconsAssistance: {
			type: Boolean,
			default: false,
		},
		lodging: {
			type: Object,
			default: null,
		},
		dayTable: {
			type: String,
			default: '',
		},
	},
	methods: {
		getStatusColor(payload) {
			switch (payload.state) {
				// success
				case 1:
					return 'green';
				// denied
				case 2:
					return 'red';
				// pending
				case 3:
					return 'orange';
				default:
					break;
			}
		},
		getNotifications(notifications, type) {
			if (type == 'asi') {
				return [];
			} else {
				notifications = uniqBy(notifications, '_id');
				const notification = notifications.find(
					not =>
						not.type == type &&
						moment(this.dayTable).isSame(moment(not.date).format('YYYY-MM-DD'))
				);

				if (notification) return [notification];
			}
		},
		filterPerDay(payload) {
			if (payload.type == 'asi') {
				if (payload.history) {
					return moment(this.dayTable).isSame(
						moment(payload.history).format('YYYY-MM-DD')
					);
				}
			} else {
				if (payload.notification) {
					return moment(this.dayTable).isSame(
						moment(payload.notification.date).format('YYYY-MM-DD')
					);
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.ifTodayQuestion {
	width: 12px;
	height: 12px;
	box-shadow: 0px 2px 7px -1px rgba(0, 0, 0, 0.35);
}
</style>
